import { useState, useEffect, useCallback, useRef } from 'react';
import { digitalTwinApi } from '../../../../Restclient/datacollection';

const STATUS_REFRESH_MS = 60 * 1000;

/**
 * Fetches ConfigGateway records merged with live IoT-Hub connection state
 * from /digital-twin/gateways. Auto-refreshes every minute so widgets can
 * reflect connect/disconnect transitions while the panel stays open.
 *
 * Each item shape:
 *   { GatewayID, Name, ..., connectionState: 'Connected' | 'Disconnected' | 'Unknown' }
 */
export function useDTGateways() {
  const [gateways, setGateways] = useState([]);
  const [loading, setLoading] = useState(true);
  const mountedRef = useRef(true);

  const fetchGateways = useCallback(async () => {
    try {
      const res = await digitalTwinApi.getGateways();
      if (!mountedRef.current) return;
      const list = res.data?.gateways || res.data || [];
      setGateways(Array.isArray(list) ? list : []);
    } catch (_) {
      if (!mountedRef.current) return;
      setGateways([]);
    } finally {
      if (mountedRef.current) setLoading(false);
    }
  }, []);

  useEffect(() => {
    mountedRef.current = true;
    fetchGateways();
    const id = setInterval(fetchGateways, STATUS_REFRESH_MS);
    return () => {
      mountedRef.current = false;
      clearInterval(id);
    };
  }, [fetchGateways]);

  return { gateways, loading, refresh: fetchGateways };
}
